<template>
  <Card class="DistributorCard">
    <div class="row">
      <div class="col-12">
        <CardBasicInfoBlock
          :data="{
            thumbnail: distributor.logo,
            title: distributor.display_name,
            action: showDistributorsDetails,
            actionText: $t('distributorCardContactDetailsButton'),
          }"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="distributorDetailsIsVisible"
      :title="$t('contactDetailsPreviewModalTitle')"
      @update:visible="hideDistributorsDetails"
    >
      <DistributorDetails :distributor="distributor" />
    </el-dialog>
  </Card>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'element-ui';
// Components
import Card from '@/components/Card.vue';
import CardBasicInfoBlock from '@/components/cardBasicInfo/Block.vue';
import DistributorDetails from '@/components/distributor/Details.vue';

Vue.use(Dialog);

export default {
  name: 'DistributorCard',
  components: {
    Card,
    CardBasicInfoBlock,
    DistributorDetails,
  },
  props: {
    distributor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      distributorDetailsIsVisible: false,
    };
  },
  computed: {
    selectedLanguage() {
      return this.$i18n.locale();
    },
  },
  methods: {
    showDistributorsDetails() {
      this.distributorDetailsIsVisible = true;
    },
    hideDistributorsDetails() {
      this.distributorDetailsIsVisible = false;
    },
  },
};
</script>
